var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v("Пожалуйста, проверьте данные перед отправкой")])])}]

export { render, staticRenderFns }